const columns = [
  {
    name: "membership_no",
    label: "Membership No.",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "name",
    label: "Name",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "ssn",
    label: "Personnummer",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "age",
    label: "Age",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "mobile",
    label: "Mobile No.",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "email",
    label: "Email",
    options: {
      filter: true,
      sort: true,
    },
  },

  {
    name: "address",
    label: "Address",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "membership_type",
    label: "Membership Type",
    options: {
      filter: true,
      sort: true,
    },
  },
];
export default columns;
